import { axiosInstance } from '../request';
const BASE_URL = '/api/v1/scheduled-prompt-tasks';
export const getReminders = async () => {
    const response = await axiosInstance.get(BASE_URL, {
        params: { limit: 100 }
    });
    return response.data.tasks;
};
export const createReminder = async (data) => {
    const response = await axiosInstance.post(BASE_URL, data);
    return response.data;
};
export const updateReminder = async (data) => {
    const { id, ...body } = data;
    const response = await axiosInstance.patch(`${BASE_URL}/${id}`, body);
    return response.data;
};
export const pauseReminder = async (id) => {
    const response = await axiosInstance.post(`${BASE_URL}/${id}/pause`);
    return response.data;
};
export const resumeReminder = async (id) => {
    const response = await axiosInstance.post(`${BASE_URL}/${id}/resume`);
    return response.data;
};
export const cancelReminder = async (id) => {
    const response = await axiosInstance.post(`${BASE_URL}/${id}/cancel`);
    return response.data;
};
//# sourceMappingURL=memoryReminders.api.js.map